import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchNewsSuppliers } from "../../services/SupplierService";
import { NewsSupplier, Supplier } from "../../types/supplier.types";

interface SupplierState {
	newsSuppliers: NewsSupplier[];
	selected?: Supplier | NewsSupplier;
	error: string | undefined;
	loading: boolean;
}

const accessToken = localStorage.getItem("accessToken");
const user = localStorage.getItem("user");

const initialState: SupplierState = {
	newsSuppliers: [],
	selected: undefined,
	error: undefined,
	loading: true,
};

const supplierSlice = createSlice({
	name: "supplier",
	initialState,
	reducers: {
		selectNewsSupplier: (state, action: PayloadAction<NewsSupplier>) => {
			state.selected = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchNewsSuppliers.fulfilled, (state, { payload }) => {
				state.loading = false;
				state.newsSuppliers = payload?.data;
				state.error = undefined;
			})
			.addCase(fetchNewsSuppliers.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message;
				state.newsSuppliers = [];
			})

	},
});

export const { selectNewsSupplier } = supplierSlice.actions;
export default supplierSlice.reducer;
